import { createFileRoute } from '@tanstack/react-router';

import { ScheduledDropsPage } from '~pages/scheduled-drops';

export const Route = createFileRoute('/_auth/scheduled-drops')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ScheduledDropsPage />;
}
